import { useEffect } from "react";
import { chatraComponent } from "../../setup/settings/index";


export default function Chatra() {
    const enabledChatra = chatraComponent.visibility;
    const idChatra = chatraComponent.id;
    useEffect(()=>{
        if(enabledChatra){
            chatraLoading()
        }
    },[])

    const chatraLoading = ()=>{
        try{
            (function(d, w, c) {
                w.ChatraID = idChatra;
                var s = d.createElement('script');
                w[c] = w[c] || function() {
                    (w[c].q = w[c].q || []).push(arguments);
                };
                s.async = true;
                s.src = 'https://call.chatra.io/chatra.js';
                if (d.head) d.head.appendChild(s);
            })(document, window, 'Chatra');
        
        }catch(error) {
            console.warn("error-loading-chatra",error)
        }
    }
    return (<></>);
}